var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainingPeaks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.269 24.166 1.83-7.149h3.92c2.089 0 3.315.57 2.9 2.297-.431 1.744-1.95 2.296-4.04 2.296h-1.554l-.639 2.538h-2.417v.018Zm4.575-3.937c.933-.035 1.416-.38 1.554-.915.138-.536-.155-.88-1.105-.916h-1.208l-.45 1.83h1.21ZM12 18.399 12.345 17h7.667l-.346 1.399h-2.555l-1.468 5.767h-2.365l1.485-5.767H12Z",
    fill: "#41474A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingPeaks);
export default __webpack_public_path__ + "static/media/trainingPeaks.56353c07a5fc46cfdd2c215d7974a39b.svg";
export { ForwardRef as ReactComponent };